<div id="signin">
  <button id="google-signin-btn" mat-button (click)="login()">
    <mat-icon svgIcon="google-icon" aria-hidden="false" aria-label="Sign In with Google"></mat-icon>
    Sign In with Google
  </button>
</div>
